import React, { useState, useRef, useEffect } from "react";
import {
    InputGroup,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { DAM_SVG } from "../DamAssets";
import DropZone from "Common/Dropzone";
import { useNavigate } from "react-router-dom";

const SearchUI = ({ search, setSearch, setMode, mode, imageSearchModal, setImageSearchModal , trash }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [imageSearchLoading, setImageSearchLoading] = useState(false);

    const toggleDropdown = () => setDropdownOpen((prev) => !prev);


    const wrapperRef = useRef(null);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setImageSearchModal(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    const navigate = useNavigate();

    return (
        <div className="d-flex justify-content-center mt-3 SearchbarAssets">

            <InputGroup
                className="shadow-sm"
            >
                {/* Mode Dropdown */}
                <Dropdown className="SearchbarAssetsDropdown" isOpen={dropdownOpen} toggle={toggleDropdown}>
                    <DropdownToggle
                        className="border-0 SearchbarAssetsDropdown"
                    >
                        {mode === 1 ? (
                            <>
                                {DAM_SVG.Search}
                            </>
                        ) : (
                            <>
                                {DAM_SVG.AI}
                            </>
                        )}
                            <img
                                style={{ paddingRight: '0.5rem', borderStyle: 'none' }}
                                src="/manage/images/arrow.svg"
                                alt="Dropdown Arrow"
                            />
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem style={{
                            padding: "10px",
                            height: "50px",
                        }} onClick={() => setMode(1)}>
                            {DAM_SVG.Search} Search
                        </DropdownItem>
                        <DropdownItem style={{
                            padding: "10px",
                            height: "50px",
                        }} onClick={() => setMode(2)}>
                            {DAM_SVG.AI} AI Search
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                {/* Input */}
                <div
                    className={`d-flex search-box justify-content-between p-2 `}
                    style={{
                        width: '20vw',
                    }}
                >
                    <div className="d-flex w-100">

                        <input
                            type="search"
                            name=""
                            placeholder="Search Assets"
                            value={search}
                            autoComplete="off"
                            // onKeyDown={KeyPress ? (e) => KeyPress(e) : undefined}
                            onChange={(e) => {
                                setSearch(e.target.value);
                            }}
                        />
                        <div
                            className="d-flex align-items-center"
                            onClick={() => {
                                setImageSearchModal(!imageSearchModal);
                            }}
                            style={{
                                cursor: 'pointer',
                            }}
                        >
                            {DAM_SVG.imageSearchIcon}
                        </div>
                    </div>
                </div>
                {/* Image Search Button */}

            </InputGroup>

            {/* Image Search Popover */}
            {imageSearchModal && (
                <div
                    className="absolute threedotsiconclickfunction2nd  filter_upper_navigator"
                    style={{
                        position: 'absolute',
                        top: '0px',
                        width: '600px',
                        padding: '20px',
                        left: '100%',
                    }}
                    ref={wrapperRef}
                >
                    <div>
                        <div className="d-flex align-items-center gap-2">
                            <div>{DAM_SVG.imageSearchIcon}</div>
                            <div className="search_image_style">Search By Image</div>
                        </div>
                    </div>
                    <div>
                        <DropZone
                            setimage={(value) => {
                                setImageSearchLoading(true);
                                setTimeout(() => {
                                    setImageSearchLoading(false);
                                    navigate(`/dam/v2/reverse-image?trash=${trash?true:false}`, {
                                        state: { data: value },
                                    });
                                }, 2000);
                            }}
                            Description={''}
                            Heading={
                                <p>
                                    Drop Your Image here or{' '}
                                    <span className="color-underline">Upload and Image</span>
                                </p>
                            }
                            Loading={imageSearchLoading}
                            fullScreen={true}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchUI;